import { render, staticRenderFns } from "./CutOffSettings.vue?vue&type=template&id=1d7ffe5a"
import script from "./CutOffSettings.vue?vue&type=script&lang=js"
export * from "./CutOffSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports